import { createI18n } from "vue-i18n";
import de from "./locales/de.json" // <--- add this
import en from "./locales/en.json"

const i18n = createI18n({
  legacy: false,
  locale: import.meta.env.VITE_DEFAULT_LOCALE,
  fallbackLocale: import.meta.env.VITE_FALLBACK_LOCALE,
  globalInjection: true,
  messages: {
    de,
    en
  }
});

export default i18n;
